import React from "react";

export default function OthersPage() {
  return (
    <div style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',height:'60vh',textAlign:'center'}}>
      <h2 style={{fontSize:'2.2rem',color:'#1976d2',marginBottom:16}}>These features are under development</h2>
      <div style={{fontSize:'1.4rem',color:'#555'}}>Coming soon.</div>
    </div>
  );
}
